import React from 'react';
import { Routes, Route, BrowserRouter as Router } from 'react-router-dom';
import Header from './assets/Header';
import Home from './assets/Home';
import Contact from './assets/Contact';
import Footer from './assets/Footer';
import Terms from './assets/Terms';
import Privacy from './assets/Privacy';
import Blockchain from './assets/Blockchain';
import AI from './assets/AI';
import About from './assets/About';
import Solutions from './assets/Solutions';
import FrontEnd from './assets/FrontEnd';
import BackEnd from './assets/Backend';
import FAQ from './assets/FAQ';

function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/Blockchain" element={<Blockchain />} />
        <Route path="/AI" element={<AI />} />
        <Route path="/About" element={<About />} />
        <Route path="/Solutions" element={<Solutions />} />
        <Route path="/FrontEnd" element={<FrontEnd />} />
        <Route path="/BackEnd" element={<BackEnd />} />
        <Route path="/FAQ" element={<FAQ />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;